import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/falken/find-a-stockist/FindAStockist_header-BG.webp'


const _withScopeId = n => (_pushScopeId("data-v-6631e55d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"stockist_banner p-0\" data-v-6631e55d><div class=\"banner_slider_wrapper\" data-v-6631e55d><div class=\"box\" data-v-6631e55d><div class=\"container wrapper\" data-v-6631e55d><div class=\"text opacity-1\" data-v-6631e55d><h1 class=\"title title_2\" data-v-6631e55d>Find a Stockist</h1><h2 class=\"title_3\" data-v-6631e55d> Find a dealer from our list of trusted partners </h2></div></div><img src=\"" + _imports_0 + "\" class=\"d-block w-100\" alt=\"Falken Banner Image\" data-v-6631e55d></div></div></section>", 1)
const _hoisted_2 = { class: "stockist_list_section" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "stockist_grid" }
const _hoisted_5 = { class: "logo_wrapper" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "button_group" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockists, (stockist, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "stockist_card"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: stockist.image,
                  alt: stockist.name,
                  class: "stockist_logo"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: stockist.storeLink,
                  target: "_blank",
                  class: "btn_stockist btn_blue"
                }, " Find a Store ", 8, _hoisted_8),
                _createElementVNode("a", {
                  href: stockist.buyLink,
                  target: "_blank",
                  class: "btn_stockist btn_red"
                }, " Buy Now ", 8, _hoisted_9)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}